import * as React from "react";
import * as React44ms from "../../../Util/form-utils/react-44ms";

import {
  DataSourceAddressAutocompleteQueryProvider,
  DataSourceAddressAutocompleteQueryProviderProps,
} from "./data-source-address-autocomplete-query";

export interface DataSourceAddressAutocompleteControllerConsumerInterface {
  request: (
    desiredAddress: DataSourceAddressAutocompleteQueryProviderProps
  ) => void;
}

const defaultValue =
  {} as unknown as DataSourceAddressAutocompleteControllerConsumerInterface;

const DataSourceAddressAutocompleteControllerContext =
  React.createContext(defaultValue);
const DataSourceAddressAutocompleteControllerContext_44 =
  React44ms.React.createContext(
    defaultValue,
    DataSourceAddressAutocompleteControllerContext
  );

export const DataSourceAddressAutocompleteControllerProvider: React.FunctionComponent =
  (props) => {
    const [desiredAddress, setDesiredAddress] =
      React.useState<DataSourceAddressAutocompleteQueryProviderProps | null>();

    const request: DataSourceAddressAutocompleteControllerConsumerInterface["request"] =
      React.useCallback((desiredAddress) => {
        if ((desiredAddress.addressToAutocomplete || "").length > 0) {
          setDesiredAddress(desiredAddress);
        } else {
          setDesiredAddress(null);
        }
      }, []);

    const value: DataSourceAddressAutocompleteControllerConsumerInterface =
      React.useMemo(
        () => ({
          request,
        }),
        [request]
      );

    return (
      <DataSourceAddressAutocompleteControllerContext.Provider value={value}>
        <DataSourceAddressAutocompleteControllerContext_44.Provider
          value={value}
        >
          <DataSourceAddressAutocompleteQueryProvider
            addressToAutocomplete={desiredAddress?.addressToAutocomplete}
            countryCode={desiredAddress?.countryCode}
          >
            {props?.children || []}
          </DataSourceAddressAutocompleteQueryProvider>
        </DataSourceAddressAutocompleteControllerContext_44.Provider>
      </DataSourceAddressAutocompleteControllerContext.Provider>
    );
  };

export const useDataSourceAddressAutocompleteController = () => {
  const context = React.useContext(
    DataSourceAddressAutocompleteControllerContext
  );
  if (context === defaultValue) {
    throw new Error(
      "useDataSourceAddressAutocompleteController must be used within a DataSourceAddressAutocompleteControllerProvider"
    );
  }
  return context;
};

export const useDataSourceAddressAutocompleteController_44 = () => {
  const context = React44ms.React.useContext(
    DataSourceAddressAutocompleteControllerContext_44
  );
  if (context === defaultValue) {
    throw new Error(
      "useDataSourceAddressAutocompleteController_44 must be used within a DataSourceAddressAutocompleteControllerProvider"
    );
  }
  return context;
};
